<template>
  <common-dialog ref="dialog" :title="title" width="1200px" :in-dialog="inDialog">
    <list ref="list" common  :isSelect="true" :show-query="true" :show-checkbox="multiple" :temp-params="{Status: 2, LineAbort: false}" :is_listDialog="true" :is-show="true"  :modelType="modelType" >
      <template #column>
        <slot name="column" />
        <template v-if="selectable&&!multiple">
          <el-table-column label="操作" align="center" width="60" fixed="right">
            <template slot-scope="{row}">
              <el-button :disabled="row.DistrictId==NoId" @click="onSelect(row)" type="text">选择</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";


export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "报价单列表",
    },
    modelType: {
      type: String,
      default: "businesssalesquotation",
    },
  },
  data() {
    return {
      params: {},
      NoId: 0,
    };
  },
  methods: {
    selectMultiple(){
      console.log('===this.$refs.list===', this.$refs.list)
      let Address=''
      let TradeUnitId=0
      let FullName=''
      let TransportId=0
      // console.log(this.$refs.list,'this.$refs.list')
      if(this.$refs.list.Address) Address=this.$refs.list.Address
      if(this.$refs.list.TradeUnitId>0) TradeUnitId=this.$refs.list.TradeUnitId
      if(this.$refs.list.FullName) FullName=this.$refs.list.FullName
      if(this.$refs.list.TransportId) TransportId=this.$refs.list.TransportId
      let data= {Order:this.$refs.list.OrderNo,List:this.$refs.list.subSelectList,Address,TradeUnitId,FullName,TransportId}
      this.$emit('select-multiple',data)
      this.close();
    },
    getData(params = {}) {
      this.params = { ...params };
      console.log('params', params)
      this.$refs.list.getData(this.params);
    },
    // treeSelect(data) {
    //   this.$refs.list.showTable({ ...this.params, IdChain: data.IdChain });
    // },
    // titleClick() {
    //   this.$refs.list.showTable({ ...this.params, IdChain: null });
    // },
  },
};
</script>